import type { PaymentsTranslations } from "../interfaces/payments";

export const paymentsTranslations: PaymentsTranslations = {
  page_title: "Solicitações de pagamento",
  button_back_to_list: "Voltar à lista",
  button_new_payment: "Novo pagamento",
  section_new_payment_title: "Novo pagamento",
  button_create_payment: "Criar pagamento",
  button_clear_form: "Limpar formulário",
  button_cancel: "Cancelar",
  toast_error_load: "Erro ao carregar pagamentos",
  toast_error_load_more: "Erro ao carregar mais pagamentos",
  toast_success_create: "Pagamento criado corretamente",
  toast_error_create: "Erro ao criar o pagamento",
  toast_success_status: "Estado atualizado corretamente",
  toast_error_status: "Erro ao atualizar o estado",
  toast_success_cancel: "Pagamento cancelado corretamente",
  toast_error_cancel: "Erro ao cancelar o pagamento",
  toast_success_take: "Pagamento tomado corretamente",
  toast_error_take: "Erro ao tomar o pagamento",
  toast_success_release: "Pagamento liberado e devolvido a pendentes",
  toast_error_release: "Erro ao liberar o pagamento",
  toast_success_notify: "Cliente notificado corretamente",
  toast_error_notify: "Erro ao notificar o cliente",
  loading: "Carregando…",
  show_more: "Mostrar mais",
  alt_comprobante_pago: "Comprovante de pagamento",

  card_status_pending: "Pendente",
  card_status_in_progress: "Em processo",
  card_status_paid: "Pago",
  card_beneficiary: "Beneficiário:",
  card_platform: "Plataforma:",
  card_date: "Data:",
  card_creation_date: "Data de criacao:",
  card_update_date: "Data de atualizacao:",
  card_note: "Nota:",
  card_created_by: "Criado por:",
  card_updated_by: "Atualizado por:",
  card_notify_client: "Cliente notificado",
  toast_success_taker_reminder: "Lembrete enviado com sucesso",
  toast_error_taker_reminder: "Erro ao enviar o lembrete",
  card_url_has_label: "url_hash",
  card_network_label: "Rede",
  card_copy: "Copiar",
  card_copied: "Copiado",
  card_copy_title: "Copiar",
  card_cancel: "Cancelar",
  card_take: "Tomar",
  card_take_continue: "Continuar",
  card_taken_by: "Tomado por {{name}}",
  card_taken_by_you: "Você já tomou este pagamento",
  card_release: "Liberar",
  card_release_admin: "Liberar (admin)",
  card_release_title: "Devolver o pagamento a pendentes para que outro usuário possa tomá-lo",
  card_view_history: "Ver histórico",
  card_verified: "Verificado",
  card_payment_info: "Informação do pagamento",
  card_receipts: "Comprovante",
  card_receipts_count: "Comprovantes",
  card_error_load: "Erro ao carregar",
  card_view: "Ver",
  card_alt_receipt_n: "Comprovante {{n}}",

  preview_payer: "Pagador:",
  preview_platform: "Plataforma:",
  preview_date: "Data:",
  preview_created_by: "Criado por:",

  column_pending: "Pendentes",
  column_in_progress: "Em processo",
  column_paid: "Pagos",
  column_empty_pending: "Não há pagamentos pendentes. Os novos pagamentos aparecerão aqui.",
  column_refresh: "Atualizar",
  column_refresh_aria: "Atualizar pagamentos",
  column_drag_in_progress: "Arraste para Em processo",
  column_drag_paid: "Arraste para Pago",

  modal_cancel_title: "Cancelar pagamento",
  modal_cancel_description:
    "Por favor, indique o motivo pelo qual deseja cancelar este pagamento. Esta ação não pode ser desfeita após confirmada.",
  modal_cancel_label_reason: "Motivo do cancelamento",
  modal_cancel_placeholder: "Escreva aqui o motivo do cancelamento...",
  modal_cancel_back: "Voltar",
  modal_cancel_confirm: "Confirmar cancelamento",
  modal_cancel_confirming: "Cancelando...",
  modal_cancel_required: "O motivo do cancelamento é obrigatório.",
  modal_cancel_close_aria: "Fechar",

  modal_take_title: "Tomar pagamento",
  modal_take_description:
    "Tem certeza que deseja tomar este pagamento? O pagamento passará ao estado «Em processo» e esta ação será registrada no histórico.",
  modal_take_back: "Voltar",
  modal_take_confirm: "Tomar",
  modal_take_processing: "Processando...",
  modal_take_close_aria: "Fechar",

  modal_release_title: "Liberar pagamento",
  modal_release_description:
    "O pagamento voltará para «Pendente» e ficará disponível para que qualquer operador o tome. Esta ação será registrada no histórico.",
  modal_release_confirm: "Liberar",
  modal_release_admin_title: "Liberar pagamento de outro operador",
  modal_release_admin_description:
    "Este pagamento está tomado por outro operador. Ao liberá-lo, ele perderá o bloqueio e o pagamento voltará para «Pendente».",
  modal_release_admin_holder: "Tomado por {{name}}",
  modal_release_admin_warning:
    "Ele pode estar trabalhando nele agora mesmo. Libere apenas se o pagamento ficou bloqueado ou se o operador não está disponível.",
  modal_release_admin_confirm: "Liberar de qualquer forma",
  modal_release_back: "Voltar",
  modal_release_processing: "Liberando...",

  modal_paid_title: "Marcar como pago",
  modal_paid_description:
    "Tem certeza que deseja marcar este pagamento como pago? O pagamento passará ao estado «Pago» e esta ação será registrada no histórico.",
  modal_paid_payment_source_label: "Saída de Banco",
  modal_paid_payment_source_placeholder: "Selecione a saída de banco",
  modal_paid_payment_source_required: "É necessário selecionar a saída de banco.",
  modal_paid_comprobante_label: "Comprovante (imagens)",
  modal_paid_comprobante_optional_label: "Comprovante (imagens) (opcional)",
  modal_paid_comprobante_description: "PNG, JPG, WebP até 10 MB. Você pode escolher vários arquivos.",
  modal_paid_comprobante_optional_description:
    "Opcional para USDT. PNG, JPG, WebP até 10 MB. Você pode escolher vários arquivos.",
  modal_paid_url_has_label: "url_hash",
  modal_paid_url_has_placeholder: "Digite url_hash",
  modal_paid_comprobante_required: "É necessário anexar pelo menos um comprovante.",
  modal_paid_url_has_required: "O campo url_hash é obrigatório para pagamentos em USDT.",
  modal_paid_back: "Voltar",
  modal_paid_confirm: "Marcar como pago",
  modal_paid_processing: "Processando...",
  modal_paid_close_aria: "Fechar",

  modal_history_title: "Histórico do pagamento",
  modal_history_loading: "Carregando histórico…",
  modal_history_error: "Não foi possível carregar o histórico.",
  modal_history_empty: "Não há registros no histórico.",
  modal_history_section_title: "Histórico de alterações",
  modal_history_initial_status: "Estado inicial",
  modal_history_previous_status: "Estado anterior",
  modal_history_current_status: "Estado atual",
  modal_history_duration: "Duração",
  modal_history_close: "Fechar",
  modal_history_close_aria: "Fechar",
  status_pending: "Pendente",
  status_in_progress: "Em processo",
  status_paid: "Pago",
  status_cancelled: "Cancelado",
  status_archived: "Arquivado",
  status_filed: "Arquivado (filed)",
  change_type_created: "Criação",
  change_type_status: "Mudança de estado",
  change_type_data: "Atualização de dados",
  change_type_attachment: "Anexo adicionado",
  change_type_note: "Nota adicionada",
  change_type_taken: "Tomado",

  modal_info_title: "Informação do pagamento",
  modal_info_no_data: "Não há informação de pagamento para este registro.",
  modal_info_amount_label: "Valor do pagamento",
  modal_info_close: "Fechar",
  modal_info_confirm_payment: "Confirmar pagamento",
  modal_info_copy_title: "Copiar",
  modal_info_copy_amount_title: "Copiar valor do pagamento",
  modal_info_yes: "Sim",
  modal_info_no: "Não",

  modal_info_field_llave_bre_b: "Chave Bre-B",
  modal_info_field_numero_celular_nequi: "Número de celular associado ao Nequi",
  modal_info_field_banco_ach: "Banco",
  modal_info_field_tipo_cuenta: "Tipo de conta",
  modal_info_field_numero_cuenta: "Número da conta",
  modal_info_field_tipo_documento: "Tipo de documento",
  modal_info_field_numero_documento: "Número do documento",
  modal_info_field_tipo_llave_pix: "Tipo de chave Pix",
  modal_info_field_llave_pix: "Chave Pix",
  modal_info_field_clabe: "CLABE (18 dígitos)",
  modal_info_field_banco: "Banco",
  modal_info_field_rut: "RUT",
  modal_info_field_email: "Email",
  modal_info_field_numero_cci: "Número CCI",
  modal_info_field_documento_identidad: "Documento de identidade",
  modal_info_field_numero_celular_yape: "Número de celular associado ao Yape",
  modal_info_field_numero_celular_plin: "Número de celular associado ao Plin",
  modal_info_field_routing_number: "Routing number",
  modal_info_field_swift_bic: "SWIFT / BIC",
  modal_info_field_direccion_banco: "Endereço do banco",
  modal_info_field_email_telefono_zelle: "Email ou número de telefone associado",
  modal_info_field_iban: "IBAN",
  modal_info_field_tipo_identificador_fps: "Tipo de identificador",
  modal_info_field_identificador_fps: "Identificador FPS",
  modal_info_field_codigo_chats: "Código CHATS",
  modal_info_field_id_alipay: "ID Alipay",
  modal_info_field_id_wechat: "ID WeChat",
  modal_info_field_numero_cuenta_iban: "Número da conta IBAN",
  modal_info_field_numero_celular: "Número de celular",
  modal_info_field_cbu_cvu: "CBU ou CVU",
  modal_info_field_cbu: "CBU",
  modal_info_field_cvu: "CVU",
  modal_info_field_direccion_wallet: "Endereço da wallet",
  modal_info_field_binance_pay_uid: "UID",
  modal_info_field_binance_pay_email: "Email",

  validation_method_field_required: "Este campo é obrigatório.",

  form_payer_subclient_placeholder: "Selecione o pagador (subcliente)",

  form_client_search_empty_message:
    "Não foram encontrados clientes com essa pesquisa. Registe-os no módulo de clientes e tente novamente.",
  form_client_search_go_to_clients: "Ir para clientes",
  form_client_search_dropdown_empty: "Sem resultados para esta pesquisa.",

  form_payer_accounts_loading: "A carregar contas do beneficiário…",
  form_payer_accounts_missing:
    "O beneficiário deve ter pelo menos uma conta registada. Aceda ao módulo de clientes e registe uma.",
  form_payer_account_label: "Conta do beneficiário",
  form_payer_account_placeholder: "Selecione uma conta",
  validation_payer_account_required: "Selecione a conta do beneficiário.",

  form_method_section_title: "Dados do método de pagamento",
  form_method_select_placeholder: "Selecionar {{label}}...",
  form_method_pix_select_type_first: "Selecione primeiro o tipo de chave",
  form_method_option_ahorros: "Poupança",
  form_method_option_corriente: "Corrente",
  form_method_option_nit: "Nit",
  form_method_option_cc: "Cc",
  form_method_option_ce: "Ce",
  form_method_option_pasaporte: "Passaporte",
  form_method_option_ppt: "Ppt",
  form_method_option_cpf: "CPF",
  form_method_option_cnpj: "CNPJ",
  form_method_option_email: "Email",
  form_method_option_telefono: "Telefone",
  form_method_option_llave_aleatoria: "Chave aleatória",
  form_method_option_id_fps: "ID FPS",

  pending_totals_title: "Totais pendentes por moeda",
  pending_totals_subtitle: "Veja rapidamente o valor total que ainda falta processar em cada moeda.",
  pending_totals_card_label: "Total pendente",
  pending_totals_loading: "Carregando totais…",
  pending_totals_empty: "Não há pagamentos pendentes no momento.",
  pending_totals_error: "Erro ao carregar os totais pendentes",
  pending_totals_refresh: "Atualizar",
  pending_totals_refresh_aria: "Atualizar totais pendentes",
};
